"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEVERITY_FAILURE = exports.SEVERITY_WARNING = exports.SEVERITY_INFO = exports.VERIFICATION_ERROR = void 0;
exports.VERIFICATION_ERROR = "VERIFICATION_ERROR";
exports.SEVERITY_INFO = 0;
exports.SEVERITY_WARNING = 1;
exports.SEVERITY_FAILURE = 2;
class VerificationError extends Error {
    constructor(message, type = VerificationError.TYPES.GENERAL_ERROR, severity) {
        super(message);
        this.severity = exports.SEVERITY_FAILURE;
        this.name = exports.VERIFICATION_ERROR;
        this.type = type;
        this.severity = typeof severity === "number" ? severity : exports.SEVERITY_FAILURE;
    }
}
VerificationError.SEVERITY_INFO = exports.SEVERITY_INFO;
VerificationError.SEVERITY_WARNING = exports.SEVERITY_WARNING;
VerificationError.SEVERITY_FAILURE = exports.SEVERITY_FAILURE;
VerificationError.TYPES = {
    GENERAL_ERROR: "GENERAL_ERROR",
    TRANSACTION_PENDING: "TRANSACTION_PENDING",
};
exports.default = VerificationError;
